import {getApiConfig, getCurrentFabricatorId} from "../../../utilities";
import {setPricingEditedFeatures, setPricingFeaturesList, setPricingFeaturesReceived} from "../pricingActions";
import {ALWAYS_REQUEST_PROPERTIES, PRICING_FEATURE_PROPERTIES} from "./pricingFeatureProperties";
import {featureIsEditedAndCanBeSaved} from "./pricingFeaturesFunctions";
import {property} from "lodash";

export const getPricingFeatures = (groupName, columns) => {
  return async (dispatch, getState) => {

    dispatch(setPricingFeaturesReceived(false));

    const fabricatorId = getCurrentFabricatorId(getState());

    // {fabricatorId:int}/groups/{groupName}/catalogs

    const requestProperties = [
      ...columns
        .filter(property => PRICING_FEATURE_PROPERTIES[property])
        .map(property => PRICING_FEATURE_PROPERTIES[property].backendName),
      ...ALWAYS_REQUEST_PROPERTIES,
    ];

    return getApiConfig(`price-list/${fabricatorId}/features/get`).post({
      FeatureGroupName: groupName,
      ManufacturerName: "",
      CatalogId: "",
      FeatureProperties: requestProperties,
      // FeatureProperties: [
      //   "Cost","FeatureDefinition_id","Costplus","BaseQuantity","MaxQuantity","ComparisonType","ComparisonFor",
      //   "ComplexLogic","ShowCostInFrontEnd","FabricatorCost","FabricatorCostplus","FabricatorBaseQuantity",
      //   "FabricatorMaxQuantity","FabricatorComparisonType","FabricatorComparisonFor","FabricatorComplexLogic",
      //   "DisplayName","HideUnitLabel","ProductNotForSale","EmployeesOnly","HideQuantity","DefaultQuantity",
      //   "GalleryEnabled","Sku","Model","Unlocked","SubDescription","AutoAddToCart","NotTaxable","UseStonePricing",
      //   "IsBundle","Height","Width","Length","DimensionMeasurements","Weight","WeightMeasurement","ShippingCost",
      //   "ShippingTime","ShippingName","ShippingMetrics","Price","PriceEditable","Catalog_Id","Name","OrderId","Flags",
      //   "ShowDescriptionTooltip","HideFromKitchenVisualizer","ImageKey","ImageDescriptionKey","FlatIconImageKey",
      //   "RawName","GroupName","IsPlaceholder","FeatureName","HideFromShopingCartOnKV","Unit","Description","Enabled",
      //   "MetaData"
      // ],
    })
      .then((response) => {
        console.log('response get features ->', response);
        dispatch(setPricingFeaturesReceived(true));
        dispatch(setPricingFeaturesList(Array.isArray(response) ? response : []));
        return response
      })
      .catch((response) => {
        console.log('error get features ->', response);
        dispatch(setPricingFeaturesReceived(true));
        dispatch(setPricingFeaturesList([]));
        return false
      });
  }
}

export const postSaveFeatures = (dispatch, store) => {

  const {pricingEditedFeatures} = store.pricingState;
  const fabricatorId = getCurrentFabricatorId(store);

  // {fabricatorId:int}/groups/{groupName}/catalogs

  const requestData = Object.keys(pricingEditedFeatures).map(featureDefinitionId => {
    if (!featureIsEditedAndCanBeSaved(pricingEditedFeatures[featureDefinitionId])) {
      return null
    }
    let Properties = {};
    Object.keys(pricingEditedFeatures[featureDefinitionId]).forEach(property => {
      if (property !== "fabricatorFeatureIds" && PRICING_FEATURE_PROPERTIES[property]) { // just in case
        Properties[PRICING_FEATURE_PROPERTIES[property].backendName] = pricingEditedFeatures[featureDefinitionId][property]
      }
    })
    return {
      "Ids": pricingEditedFeatures[featureDefinitionId].fabricatorFeatureIds,
      "Properties": Properties
    }
  }).filter(reqObject => reqObject);

  if (!requestData.length) {
    return Promise.resolve()
  }

  return getApiConfig(`price-list/${fabricatorId}/features/update`).post(requestData)
    .then((response) => {
      console.log('response update features ->', response);
      dispatch(setPricingEditedFeatures({}));
      return response
    })
    .catch((error) => {
      console.log('error update features ->', error);
      return Promise.reject(error)
    });
}
